import { NumberedAccordion } from '~/ui-rocco/pages/detail-shared';
import { useProductAccordionRows } from './spec-accordion/use-product-accordion-rows';

/**
 * F7 — numbered spec accordion. The rows (and the "(NN)" numbering source) are
 * built by {@link useProductAccordionRows}; this just adds the design's 80px
 * spacer above each row's content and renders the accordion.
 */
export const ProductSpecAccordionSection = ({
    runIn,
}: {
    /**
     * The gap to whatever sits above, as Tailwind padding classes. Owned by
     * this section rather than left as a spacer on the page: this section is
     * absent on many products, and a page-level spacer then stacked against
     * the next one and doubled that section's run-in.
     */
    runIn: string;
}) => {
    const { rows, defaultOpenTitles } = useProductAccordionRows();

    // Nothing to fold away on a product with no rows, and an empty accordion
    // still occupied the page: its spacers stacked against the next section's
    // and doubled that section's run-in.
    if (!rows.length) return null;

    // The design (1846:9004 et al) puts an 80px spacer between the trigger and
    // every row's content, and 80px below it (contents carry 1.8rem already).
    const spacedRows = rows.map((row) => ({
        ...row,
        content: (
            <div className="pt-[5rem] pb-[3.2rem] max-md:pt-6 max-md:pb-4">
                {row.content}
            </div>
        ),
    }));

    return (
        <NumberedAccordion
            className={`max-md:px-5 qhd:overflow-x-clip md:px-[3rem] ${runIn}`}
            headingLevel={2}
            rows={spacedRows}
            multiple
            defaultOpenTitles={defaultOpenTitles}
        />
    );
};
